<div [innerHTML]="templateAsString() | safe" [style]="styles()"></div>
